import { render, staticRenderFns } from "./NavigationNavListSemesters.vue?vue&type=template&id=58788c16"
import script from "./NavigationNavListSemesters.vue?vue&type=script&lang=js"
export * from "./NavigationNavListSemesters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports